import { MobilePhonePipe } from '../../shared/pipes/mobile.pipe';

export function mobilePhone ( mobilePhonePipe : MobilePhonePipe ) {
  return ( value : string ) : string => mobilePhonePipe.transform(value);
}
